import { apiGet, apiPost } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const activityStatsApi = {
  /**
   * @apiRoute GET '/stats/work-activity/insights/last-updated'
   */
  async getLastUpdated() {
    try {
      return await apiGet(getPath('stats/work-activity/insights/last-updated'));
    } catch (err) {
      await handleApiError(
        err,
        'getLastUpdated',
        true,
        'Error fetching last updated'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/work-activity/details'
   */
  async getDetails(payload) {
    try {
      return await apiPost(getPath('stats/work-activity/details'), payload);
    } catch (err) {
      await handleApiError(err, 'getDetails', true, 'Error fetching details');
    }
  },

  /**
   * @apiRoute POST '/stats/work-activity/insights/<type>'
   */
  async getAverageTotalInsights(payload) {
    try {
      return await apiPost(
        getPath('stats/work-activity/insights/average-total'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getAverageTotalInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/work-activity/insights/<type>'
   */
  async getMonthlyInsights(payload) {
    try {
      return await apiPost(
        getPath('stats/work-activity/insights/monthly'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getMonthlyInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST 'stats/work-activity/insights/<type>'
   */
  async getMostActiveDays(payload) {
    try {
      return await apiPost(
        getPath('stats/work-activity/insights/most-active-days'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getMostActiveDays',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/work-activity/insights/<type>'
   */
  async getLeaderboard(payload) {
    try {
      return await apiPost(
        getPath('stats/work-activity/insights/leaderboard'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getLeaderboard',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/work-activity/insights/<type>'
   */
  async getTopActivityCodes(payload) {
    try {
      return await apiPost(
        getPath('stats/work-activity/insights/top-activity-codes'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getTopActivityCodes',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/work-activity/breakout/<type>'
   */
  async getBreakoutChart(payload) {
    try {
      return await apiPost(
        getPath('stats/work-activity/breakout/chart'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getBreakoutChart',
        true,
        'Error fetching breakout chart'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/work-activity/breakout/<type>'
   */
  async getBreakoutTable(payload) {
    try {
      return await apiPost(
        getPath('stats/work-activity/breakout/table'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getBreakoutTable',
        true,
        'Error fetching breakout table'
      );
    }
  },
};
